export const TITLES = ["Mr", "Mrs", "Ms", "Mx", "Dr", "Prof"];

// Country name + international dialling code. Europe-first, then common markets.
export const COUNTRIES = [
  { n: "United Kingdom", d: "+44" },
  { n: "Sweden", d: "+46" },
  { n: "Germany", d: "+49" },
  { n: "Netherlands", d: "+31" },
  { n: "France", d: "+33" },
  { n: "Switzerland", d: "+41" },
  { n: "Austria", d: "+43" },
  { n: "Belgium", d: "+32" },
  { n: "Denmark", d: "+45" },
  { n: "Norway", d: "+47" },
  { n: "Finland", d: "+358" },
  { n: "Ireland", d: "+353" },
  { n: "Spain", d: "+34" },
  { n: "Portugal", d: "+351" },
  { n: "Italy", d: "+39" },
  { n: "Greece", d: "+30" },
  { n: "Poland", d: "+48" },
  { n: "Czechia", d: "+420" },
  { n: "Luxembourg", d: "+352" },
  { n: "Iceland", d: "+354" },
  { n: "United States", d: "+1" },
  { n: "Canada", d: "+1" },
  { n: "United Arab Emirates", d: "+971" },
  { n: "Saudi Arabia", d: "+966" },
  { n: "Qatar", d: "+974" },
  { n: "Australia", d: "+61" },
  { n: "New Zealand", d: "+64" },
  { n: "Singapore", d: "+65" },
  { n: "Hong Kong", d: "+852" },
  { n: "Japan", d: "+81" },
  { n: "China", d: "+86" },
  { n: "India", d: "+91" },
  { n: "Sri Lanka", d: "+94" },
  { n: "Maldives", d: "+960" },
  { n: "Thailand", d: "+66" },
  { n: "Indonesia", d: "+62" },
  { n: "Malaysia", d: "+60" },
  { n: "South Africa", d: "+27" },
  { n: "Russia", d: "+7" },
  { n: "Turkey", d: "+90" },
  { n: "Israel", d: "+972" },
  { n: "Brazil", d: "+55" },
  { n: "Mexico", d: "+52" },
  { n: "Other", d: "+" },
];

export const DIAL_CODES = Array.from(new Set(COUNTRIES.map((c) => c.d))).filter((d) => d !== "+").sort((a, b) => a.localeCompare(b));

export const isValidEmail = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((e || "").trim());
